import React from "react";
import { formatYearsOfManufacture } from "../../helpers/formatYearsOfManufacture";

interface IVehicleVariantCardProps {
  bodyType: string;
  capCode: string;
  carDetails: string;
  engineSize: number;
  handleSelectClick: (capCode: string) => void;
  derivative: string;
  transmission: string;
  derivativeYearIntroduced: string;
  derivativeYearDiscontinued: string;
}
export const VehicleVariantCard = ({
  bodyType,
  capCode,
  carDetails,
  engineSize,
  handleSelectClick,
  derivative,
  transmission,
  derivativeYearIntroduced,
  derivativeYearDiscontinued
}: IVehicleVariantCardProps) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleSelectClick((event.target as HTMLInputElement).value);
  };

  return (
    <div
      className="ch-card ch-mb--2 ch-shadow--sm"
      data-testid="variant-option"
    >
      <div className="ch-card__content">
        <table>
          <tbody className="variant-details-table">
            <tr>
              <td className="ch-fw--500">Model</td>
              <td>{derivative}</td>
            </tr>
            <tr>
              <td></td>
              <td>{carDetails}</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className="ch-fw--500">Body type</td>
              <td>{bodyType}</td>
            </tr>
            <tr>
              <td className="ch-fw--500">Engine size</td>
              <td>{engineSize}</td>
            </tr>
            <tr>
              <td className="ch-fw--500">Transmission</td>
              <td>{transmission}</td>
            </tr>
            <tr>
              <td className="ch-fw--500">Years of manufacture</td>
              <td className="variant-details-table--align-bottom">
                {formatYearsOfManufacture(
                  derivativeYearIntroduced,
                  derivativeYearDiscontinued
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <button
          className="ch-btn ch-btn--primary ch-display--block ch-mh--auto ch-width--12 ch-mt--3"
          onClick={handleClick}
          value={capCode}
          data-testid="variant-select"
        >
          Select &nbsp; {">"}
        </button>
      </div>
    </div>
  );
};
